export default __webpack_public_path__ + "static/media/licitatii.4f4ad1bc.png";